(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            console.log(text);
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');
              let cardHeight = parseInt(sameCard.clientHeight);
              let topValue = cardHeight / 2 + 5;
              let cardTopCSS = "calc(50% - "+topValue+'px)';
              let swiperContainer = document.querySelector('.product-recommendations .swiper');
              let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
              let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
              swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
              swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sabaayat-shop"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initShop(root = document) {
      root.querySelectorAll('[data-live-shop]:not([data-shop-ready])').forEach(shop => {
        shop.dataset.shopReady = 'true';
        if (shop.querySelector('[data-demo-grid]')) return;
        const grid = shop.querySelector('[data-shop-grid]');
        if (!grid) return;
        const items = [...grid.querySelectorAll('[data-shop-product]')];
        const initialOrder = new Map(items.map((item, index) => [item, index]));
        const pagination = shop.querySelector('[data-shop-pagination]');
        const count = shop.querySelector('[data-result-count]');
        const empty = shop.querySelector('[data-shop-empty]');
        const sort = shop.querySelector('[data-shop-sort]');
        const filterToggle = shop.querySelector('[data-shop-filter-open]');
        const filterDrawer = shop.querySelector('[data-shop-filter-drawer]');
        const filterBackdrop = shop.querySelector('[data-shop-filter-backdrop]');
        const filterBadge = shop.querySelector('[data-shop-filter-count]');
        const filterResults = shop.querySelector('[data-shop-filter-results]');
        const mobileView = window.matchMedia('(max-width: 749px)');
        let previousBodyOverflow = '';
        function closeFilters(restoreFocus = true) {
          if (!shop.classList.contains('shop-filters-open')) return;
          shop.classList.remove('shop-filters-open');
          filterToggle.setAttribute('aria-expanded', 'false');
          filterBackdrop.hidden = true;
          filterDrawer.removeAttribute('role');
          filterDrawer.removeAttribute('aria-modal');
          filterDrawer.inert = mobileView.matches;
          document.body.style.overflow = previousBodyOverflow;
          if (restoreFocus && mobileView.matches) filterToggle.focus();
        }
        function openFilters() {
          if (!mobileView.matches) return;
          previousBodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          filterDrawer.inert = false;
          filterDrawer.setAttribute('role', 'dialog');
          filterDrawer.setAttribute('aria-modal', 'true');
          filterBackdrop.hidden = false;
          filterToggle.setAttribute('aria-expanded', 'true');
          shop.classList.add('shop-filters-open');
          filterDrawer.querySelector('[data-shop-filter-close]').focus();
        }
        filterDrawer.inert = mobileView.matches;
        filterToggle.addEventListener('click', openFilters);
        filterBackdrop.addEventListener('click', () => closeFilters());
        filterDrawer.querySelector('[data-shop-filter-close]').addEventListener('click', () => closeFilters());
        filterDrawer.querySelector('[data-shop-filter-apply]').addEventListener('click', () => closeFilters());
        filterDrawer.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); closeFilters(); return; }
          if (event.key !== 'Tab' || !shop.classList.contains('shop-filters-open')) return;
          const focusable = [...filterDrawer.querySelectorAll('a, button, input, summary')].filter(element => element.getClientRects().length && !element.disabled);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        });
        mobileView.addEventListener('change', () => { closeFilters(false); filterDrawer.inert = mobileView.matches; });
        const pageSize = Math.max(1, Number(shop.dataset.pageSize) || 6);
        const names = ['sb_size', 'sb_colour', 'sb_price'];
        function state() {
          const params = new URLSearchParams(location.search);
          return {params, sizes: params.getAll('sb_size'), colours: params.getAll('sb_colour'), prices: params.getAll('sb_price'), sort: params.get('sb_sort') || 'featured', page: Math.max(1, Number(params.get('sbpage')) || 1)};
        }
        function priceMatches(price, ranges) {
          return !ranges.length || ranges.some(range => {
            if (range === 'under-10000') return price < 1000000;
            if (range === '10000-20000') return price >= 1000000 && price < 2000000;
            if (range === '20000-30000') return price >= 2000000 && price < 3000000;
            if (range === 'over-30000') return price >= 3000000;
            return false;
          });
        }
        function pageLink(label, page, current) {
          const link = document.createElement('a');
          const url = new URL(location.href);
          if (page === 1) url.searchParams.delete('sbpage'); else url.searchParams.set('sbpage', String(page));
          link.href = url.pathname + url.search;
          link.textContent = label;
          if (current) { link.className = 'current'; link.setAttribute('aria-current', 'page'); }
          link.addEventListener('click', event => { event.preventDefault(); history.pushState(null, '', link.href); render(); shop.scrollIntoView({block: 'start', behavior: 'smooth'}); });
          return link;
        }
        function render() {
          const s = state();
          shop.querySelectorAll('input[name="sb_size"],input[name="sb_colour"],input[name="sb_price"]').forEach(input => { input.checked = s.params.getAll(input.name).includes(input.value); });
          sort.value = s.sort;
          const ordered = [...items].sort((a, b) => {
            if (s.sort === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
            if (s.sort === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
            if (s.sort === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title);
            if (s.sort === 'title-descending') return b.dataset.title.localeCompare(a.dataset.title);
            if (s.sort === 'created-descending') return Number(b.dataset.created) - Number(a.dataset.created);
            return initialOrder.get(a) - initialOrder.get(b);
          });
          ordered.forEach(item => grid.appendChild(item));
          const matching = ordered.filter(item => {
            const itemSizes = item.dataset.sizes.split('|');
            return (!s.sizes.length || s.sizes.some(size => itemSizes.includes(size))) &&
              (!s.colours.length || s.colours.includes(item.dataset.colour)) &&
              priceMatches(Number(item.dataset.price), s.prices);
          });
          const pages = Math.max(1, Math.ceil(matching.length / pageSize));
          const page = Math.min(s.page, pages);
          ordered.forEach(item => { item.hidden = true; });
          matching.slice((page - 1) * pageSize, page * pageSize).forEach(item => { item.hidden = false; });
          count.textContent = matching.length + (matching.length === 1 ? ' style' : ' styles');
          const activeFilters = s.sizes.length + s.colours.length + s.prices.length;
          filterBadge.hidden = activeFilters === 0;
          filterBadge.textContent = String(activeFilters);
          filterResults.textContent = count.textContent;
          empty.hidden = matching.length !== 0;
          pagination.replaceChildren();
          if (pages > 1) {
            if (page > 1) pagination.appendChild(pageLink('‹ Previous', page - 1, false));
            for (let number = 1; number <= pages; number++) pagination.appendChild(pageLink(String(number), number, number === page));
            if (page < pages) pagination.appendChild(pageLink('Next ›', page + 1, false));
          }
        }
        shop.addEventListener('change', event => {
          if (names.includes(event.target.name)) {
            const params = new URLSearchParams(location.search);
            params.delete(event.target.name);
            shop.querySelectorAll('input[name="' + event.target.name + '"]:checked').forEach(input => params.append(input.name, input.value));
            params.delete('sbpage');
            history.pushState(null, '', location.pathname + (params.size ? '?' + params : ''));
            render();
          }
          if (event.target === sort) {
            const params = new URLSearchParams(location.search);
            if (sort.value === 'featured') params.delete('sb_sort'); else params.set('sb_sort', sort.value);
            params.delete('sbpage');
            history.pushState(null, '', location.pathname + (params.size ? '?' + params : ''));
            render();
          }
        });
        shop.querySelector('[data-shop-clear]').addEventListener('click', () => {
          const params = new URLSearchParams(location.search);
          names.forEach(name => params.delete(name));
          for (const key of [...params.keys()]) if (key.startsWith('filter.')) params.delete(key);
          params.delete('sbpage');
          history.pushState(null, '', location.pathname + (params.size ? '?' + params : ''));
          render();
        });
        window.addEventListener('popstate', render);
        render();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initShop()); else initShop();
    document.addEventListener('shopify:section:load', event => initShop(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
